module.exports = __webpack_public_path__ + "static/media/logo_nuevo.9ff93889.png";